import { useState, useContext } from 'react'
import TripsContext from '../contexts/TripsContext'
import { CAR_STATUS, sortAsc, sortDesc } from '../utils'

const SORT_DEFAULT = 1
const SORT_VEHICLE = 2
const SORT_DRIVER = 3
const SORT_MORE_UPDATED = 4
const SORT_LESS_UPDATED = 5
const SORT_MOVING_FIRST = 6
const SORT_STOPED_FIRST = 7
const SORT_DISCONNECT_FIRST = 8

const ASC = 1
const DESC = 2

const getSortProp = (optionId: number) => {
    switch (optionId) {
        case SORT_VEHICLE:
            return {
                path: 'name',
                order: ASC
            }
        case SORT_DRIVER:
            return {
                path: 'driver',
                order: ASC
            }
        case SORT_MORE_UPDATED:
            return {
                path: 'time',
                order: DESC
            }
        case SORT_LESS_UPDATED:
            return {
                path: 'time',
                order: ASC
            }
        case SORT_MOVING_FIRST:
            return {
                path: 'car_status',
                order: ASC
            }
        case SORT_STOPED_FIRST:
            return {
                path: 'car_status',
                order: ASC
            }
        case SORT_DISCONNECT_FIRST:
            return {
                path: 'car_status',
                order: DESC
            }
        default:
            return {
                path: 'time',
                order: DESC
            }
    }
}

const options = [
    // { id: SORT_DEFAULT, value: 'Padrão' },
    // { id: SORT_VEHICLE, value: 'Nome do Veículo' },
    // { id: SORT_DRIVER, value: 'Nome do Motorista' },
    { id: SORT_MORE_UPDATED, value: 'Mais Atualizados' },
    { id: SORT_LESS_UPDATED, value: 'Menos Atualizados' },
    // { id: SORT_MOVING_FIRST, value: 'Movendo Primeiro' },
    // { id: SORT_STOPED_FIRST, value: 'Parados Primeiro' },
    // { id: SORT_DISCONNECT_FIRST, value: 'Desconectados Primeiro' }
]

export const useSortVehicle = (eleRef: any): any[] => {
    const { hardwareData } = useContext(TripsContext)
    const [optionSelected, setOptionSelected] = useState<any>(options[0])
    const [sortActive, setSortActive] = useState<number>(SORT_DEFAULT)
    const executeScroll = () => {
        if (eleRef && eleRef.current) {
            eleRef?.current.scrollIntoView({ behavior: 'smooth' })
        }
    }

    const sortVehicles = (vehicles, option: any) => {
        const { id } = option
        let vehiclesSorted
        const vehiclesData = getVehiclesData(vehicles)

        setOptionSelected(option)
        setSortActive(id)

        const status = getStatus(id)
        const sortPropId = getSortProp(id)
        const sortPropMoreUpdated = getSortProp(SORT_MORE_UPDATED)

        if (status != null) vehiclesSorted = sort(sortPropMoreUpdated, vehiclesData, status)
        else vehiclesSorted = sort(sortPropId, vehiclesData, status)

        // executeScroll()

        return vehiclesSorted
    }

    const getStatus = sortId => {
        if (sortId === SORT_MOVING_FIRST) return 'moving'
        if (sortId === SORT_STOPED_FIRST) return 'stopped'
        if (sortId === SORT_DISCONNECT_FIRST) return 'disconnected'

        return null
    }

    const transformToValidJSONString = (inputString: string): string => {
        let jsonString = inputString

        if (inputString == undefined) return ''

        // Substituir os caracteres inválidos para JSON
        jsonString = jsonString.replace(/=/g, ': ')
        jsonString = jsonString.replace(/([a-zA-Z0-9]+)(?=\s*:)/g, '"$1"')

        // Adicionar aspas duplas em torno dos valores
        jsonString = jsonString.replace(/(?<=:\s*)([a-zA-Z0-9]+)/g, '"$1"')

        return jsonString
    }

    const getVehiclesData = vehicles => {
        if (!vehicles) return []

        for (const vehicle of vehicles) {
            vehicle.tmpHardwareData = hardwareData[vehicle.imei]

            if (vehicle.tmpHardwareData?.time) {
                vehicle.tmpHardwareData.time = +vehicle.tmpHardwareData.time
                vehicle.precedence = 1
            } else {
                vehicle.precedence = -1
            }

            vehicle.trackingStatus = vehicle.tmpHardwareData?.trackingStatus || undefined

            vehicle.sortKeys = {
                time: vehicle.tmpHardwareData?.time || undefined,
                car_status: vehicle.tmpHardwareData?.car_status || undefined,
                name: vehicle?.name || undefined,
                driver: vehicle?.driver || undefined
            }
        }

        return vehicles
    }

    const sort = (sortProp: any = {}, vehicles: any[] = [], status = undefined) => {
        const { path, order } = sortProp
        if (order === ASC) return sortAsc(path, vehicles, status)
        else if (order === DESC) return sortDesc(path, vehicles, status)
    }

    return [options, optionSelected, sortVehicles]
}
